<template>
    <div class="container">
        <main class="sub-content">
            <div class="tit"><RouteBack />재고조사</div>
                <article class="sub">
                <section class="box-bg search-area">
                    <div class="row row_jsa">
                        <dl>
                            <dt>조사번호</dt>
                            <dd>
                                <DxTextBox
                                    ref="scan"
                                    v-model="searchData.researchNum"
                                    placeholder="조사번호"
                                />
                            </dd>
                        </dl>
                        <dl>
                            <dt>보관위치</dt>
                            <dd>
                                <dxSelectCodeList
                                    ref = "strgPstnValRef"
                                    cmnsCdGrpId="STRG_PSTN_VAL"
                                    allYn="Y"
                                    v-model="searchData.strgPstnVal"
                                />
                            </dd>
                        </dl>
                    </div>
                    <div class="row row_jsa" :style="{'margin-top': '10px'}">
                          <dl>
                            <dt>보관상자번호</dt>
                            <dd>
                                <DxTextBox
                                    ref="boxScan"
                                    name="boxScan"
                                    v-model="searchData.strgBoxNum"
                                />
                            </dd>
                        </dl>
                        <dl>
                            <dt>SCAN</dt>
                            <dd>
                                <DxTextBox
                                    ref="scan"
                                    name="scan"
                                    v-model="searchData.scan"
                                    @enterKey="handleTextEnter"
                                    @paste="handleTextPaste"
                                />
                            </dd>
                        </dl>
                    </div>
                    <div class="taC">
                        <a class="btn bg-default" @click="search()">조회</a>
                        <a class="btn bg-default" @click="researchOpertaion()">재고조사반영</a>
                        <a class="btn bg-default" @click="reset()">초기화</a>
                    </div>
                </section>
            </article>
            <section>
                 <div class="grid_area">
                    <DxDataGrid
                        id="stockResearchGrid"
                        ref="stockResearchGrid"
                        key-expr="mngtNmrd"
                        :show-borders="true"
                        :selected-row-keys="selectedRowKeys"
                        @selection-changed="onSelectionChanged"
                        :data-source="items"
				                :column-auto-width="true"
                        heigh="200px"
                        confirmMessage="false"
                        @row-prepared="handleRowPrepared"
                    >
                        <DxEditing
                            mode="row"
                            :allow-deleting="false"
                            :confirm-delete="false"
                        >
                        </DxEditing>
                        <DxSelection
                            show-check-boxes-mode="always"
                            mode="multiple"
                        />
                        <DxColumn data-field="mngtNmrd" caption="mngtNmrd"  :visible="false" :sort-index="0" sort-order="desc"/>
                        <DxColumn data-field="mngtNum" caption="관리번호" />
                        <DxColumn data-field="invtRsrcMngtNum" caption="조사번호" />
                        <DxColumn data-field="invtRsrcStrgPstnNm" caption="조사위치" />
                        <DxColumn data-field="invtRsrcStrgRackNum" caption="조사랙" />
                        <DxColumn data-field="invtRsrcStrgBoxNum" caption="조사박스번호" />
                        <DxColumn data-field="invtRsrcConfNm" caption="조사자" />
                        <DxColumn data-field="invtRsrcRflcNm" caption="반영자" />
                        <DxColumn data-field="invtRsrcRflcDt" caption="반영일자" />
                        <DxColumn data-field="bfStrgPstnNm" caption="보관위치" />
                        <DxColumn data-field="bfStrgRackNum" caption="보관랙" />
                        <DxColumn data-field="bfStrgBoxNum" caption="보관상자번호" />
                        <DxColumn data-field="invtStatNm" caption="상태" />
                        <DxColumn data-field="pgrpNm" caption="상품군" />
                        <DxColumn data-field="modlNm" caption="BOS모델명" />
                        <DxColumn data-field="ptnmNm" caption="펫네임명" />
                        <DxScrolling mode="virtual"/>
                    </DxDataGrid>
                </div>
            </section>
        </main>
    </div>
</template>
<script>
import Vue from 'vue'
import {
  DxDataGrid,
  DxColumn,
  DxSelection,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxScrolling
} from 'devextreme-vue/data-grid'
import moment from 'moment'
import AppConfig from '@/config'
import DxSelectCodeList from '@/components/DxSelectCodeList'
import DxTextBox from 'devextreme-vue/text-box'
import DxDateBox from 'devextreme-vue/date-box'
import CustomStore from 'devextreme/data/custom_store'
import RouteBack from '@/components/RouteBack.vue'
export default {
    name: '',
    components: {
        RouteBack,
        DxScrolling,
        DxPaging,
        DxSelection,
        DxDataGrid,
        DxColumn,
        DxEditing,
        DxDateBox,
        DxTextBox,
        CustomStore,
        DxSelectCodeList
    },
    data() {
        return {
            searchData: {
                researchNum: moment().format("YYYYMMDD"),
                cntrCd: '100',
                tabId: 10,
                boxScan:'',
                scan:'',
                strgPstnVal: '',
                strgBoxNum: ''
            },
            items: [],
            selectedRowData: [],
        }
    },
    methods: {
        async init(){
            this.items = await this.getData();
        },
        async search(){
            this.selectedRowData = [];
			      this.items = await this.getData();
		},
        async getData(){
            const { data } = await Vue.httpClient.post('/api/warehouse/stock/researchList', this.searchData)
            return data.result;
        },
        async getRescanData(mngtNum){
            const params = {
                researchNum: this.searchData.researchNum,
                cntrCd: '100',
                tabId:10,
                mngtNum: mngtNum
            }
            const { data } = await Vue.httpClient.post('/api/warehouse/stock/researchScan', params);
            return data.result;
        },
        async handleTextEnter(e){
            //const { name } = e.event.target;
            //const scanData = name === 'scan' ? this.searchData.scan : this.searchData.boxScan;

            const scanData = this.searchData.scan;
            var name = scanData.slice(0,1) != '@' ? 'scan' : 'boxScan';
            await this.listUp(scanData, name);
            //name === 'scan' ? (this.searchData.scan ='') : (this.searchData.boxScan = '');
            this.$refs.scan.instance.focus();
            this.searchData.scan ='';
        },
        async handleTextPaste (e) {
            e.event.stopPropagation();
            e.event.preventDefault();
            //const { name } = e.event.target;
            let clipboardData = e.event.clipboardData || window.clipboardData;
            if (!clipboardData) {
                return;
            }
            const lines = clipboardData.getData('text').split(/\r\n/g)
                .reduce((acc, cur) => {
                if (cur && cur.trim() && cur.length) acc.push(cur.trim())
                    return acc;
                }, []);
              var name = '';
              for (let line of lines) {
                name = line.slice(0,1) != '@' ? 'scan' : 'boxScan';
                await this.listUp(line, name);
              }

            this.$refs.scan.instance.focus();
            //name === 'scan' ? this.$refs.scan.instance.focus() : this.$refs.boxScan.instance.focus();
        },
        async listUp (num, targetName) {
            if (!num) {
                return;
            }
            num = num.toUpperCase();
            let resultData = [];

            if(targetName === 'scan') {
                const data = await this.researchAdd(num, targetName);
                if(data.resultCode == '-501'){
                  await window.$Alert.alert('관리번호 : '+data.mngtNum+'<br>해당 재고를 찾을수 없습니다.');
                  await this.$refs.scan.instance.focus();
                  return;
                }

                if(data.resultCode == '-502'){
                  await window.$Alert.alert('관리번호 : '+data.mngtNum+'<br>포장박스번호 : '+data.pckgBoxNum+'<br>해당 관리번호는 박스에 포장되어있습니다.<br>포장해제 후 스캔해주세요.');
                  await this.$refs.scan.instance.focus();
                  return;
                }

                const reScanData = await this.getRescanData(data.mngtNum);
                if(!reScanData){
                    return;
                }

                resultData = reScanData;
                //this.selectedRowData.push(mngtNmrd);
            } else {
                const list = await this.researchBoxAdd(num);
                if(!list){
                    return;
                }

                if(list[0].resultCode == '-503'){
                  await window.$Alert.alert('박스번호 ' + list[0].pckgBoxNum + '을 찾을 수 없습니다.');
                  this.$refs.scan.instance.focus()
                  return
                }

                resultData = list;

                /*
                list.forEach(data => {
                    this.selectedRowData.push(data.mngtNmrd);
                });
                */
            }

            resultData.forEach((data) => {
                  var index = this.$refs.stockResearchGrid.instance.getRowIndexByKey(data.mngtNmrd)
                  if(index === -1) {
                     this.items.push(data);
                     this.selectedRowData.push(data.mngtNmrd);
                  } else {
                     this.$refs.stockResearchGrid.instance.deleteRow(index)
                     this.$refs.stockResearchGrid.instance.refresh()
                     this.items.push(data)
                     this.selectedRowData.push(data.mngtNmrd);
                  }
            });

           this.selectedRowData = [...new Set(this.selectedRowData)];

           const listMngtFoucs = resultData.filter(item => item.cnt > 1)
           if(listMngtFoucs.length > 0){
              window.$Alert.alert('동일한 관리번호 데이터가 있습니다.');
           }
        },
        async researchBoxAdd(boxNum) {
            const param = {
                cntrCd: '100',
                labelScan: boxNum,
                researchNum: this.searchData.researchNum,
                vStrgPstnVal: this.searchData.strgPstnVal,
                vStrgBoxNum: this.searchData.strgBoxNum,
                vStrgRackNum: ''
            };
            try {
                const { data } = await Vue.httpClient.post('/api/warehouse/stock/researchBoxAdd', param);
                if (data.status === AppConfig.HTTP_RESPONSE_SUCCESS && data.result) {
                    return data.result;
                }
            } catch(e){
                return;
            }
        },
        async researchAdd (mngtNum) {
            const param = {
                mngtNum: mngtNum,
                researchNum: this.searchData.researchNum,
                strgPstnVal: this.searchData.strgPstnVal,
                strgBoxNum: this.searchData.strgBoxNum
            };
            try {
                const { data } = await Vue.httpClient.post('/api/warehouse/stock/researchAdd', param);
                if (data.status === AppConfig.HTTP_RESPONSE_SUCCESS && data.result) {
                    return data.result;
                }
            }catch(e) {
                return;
            }
        },
        async researchOpertaion(){
            const checkedItems = this.getChekedItems();
            if(!checkedItems.length){
                window.$Alert.alert('선택된 재고조사 항목이 없습니다.');
                return;
            }

            // 재고조사 반영시 동일한 관리번호가 있는지 확인 합니다.
            // 있을 경우 첫번째 동일한 관리번호로 Focus 이동 후 메세지 처리.
            const listMngtFoucs = checkedItems.filter(item => item.cnt > 1)
            if(listMngtFoucs.length > 0){
                var sMngtNum = ""
                for(var i=0;i < listMngtFoucs.length ; i++){
                  if(i==0) {
                    sMngtNum = listMngtFoucs[i].mngtNum
                  } else sMngtNum = sMngtNum + listMngtFoucs[i].mngtNum
                }

                window.$Alert.alert('동일한 관리번호 데이터가 있습니다.');
                return
            }

            const targetItems = checkedItems.filter(item => item.invtRsrcRflcId === null && item.invtRsrcRflcDt === null)
            if(targetItems.length === 0){
                window.$Alert.alert('이미 처리되어있어 수정 할 수 없습니다.');
                return
            }

            let strgPstnValName = this.$refs.strgPstnValRef.codeList.filter(v => v.cmnsCd === this.searchData.strgPstnVal)[0].cmnsCdNm;
            strgPstnValName = strgPstnValName === '전체' ? '' : `보관위치 ${strgPstnValName} 로<br>`;
            const isTrue = await window.$Alert.confirm(`${strgPstnValName}${checkedItems.length}건 재고조사반영 하시겠습니까?`);
            if (!isTrue)  {
                return
            }
            /*
            const convertData = strgPstnValName === '전체' ? targetItems : targetItems.map(dataMap => {
                dataMap['invtRsrcStrgPstnVal'] = this.searchData.strgPstnVal;
                return dataMap;
            })
            */
            const { data } = await this.$http.post('/api/warehouse/stock/researchOperation', targetItems);
            if (data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
                if (data.result === '0') {
                    window.$Alert.alert('재고조사 반영이 처리되지 않았습니다.');
                } else {
                    window.$Alert.alert(`${data.result}건이 재고조사 반영 처리되었습니다.`);
                    this.search();
                }
            }

        },
        getChekedItems(){
            const checkedItems = this.items.filter(data => this.selectedRowData.includes(data.mngtNmrd));
            return checkedItems;
        },
        onSelectionChanged(selectedRow) {
           this.selectedRowData = selectedRow.selectedRowKeys;
        },
        handleRowPrepared (e) {
          this.$nextTick(() => {
            const { rowType, data, cells } = e
            if (rowType === 'data') {
                if(data.cnt > 1){
                    for (let cell of cells) {
                        if (cell.cellElement) cell.cellElement.classList.add('red')
                    }
                }
            }
          })
        },
        reset() {
            this.searchData = {
                                researchNum: moment().format("YYYYMMDD"),
                                cntrCd: '100',
                                tabId: 10,
                                boxScan:'',
                                scan:'',
                                strgPstnVal: ''
                              }
            this.items = []
            this.selectedRowData = []
        }
    },
    computed: {
        selectedRowKeys() {
            return this.selectedRowData;
        },
    },
    mounted() {
        this.init();
        // this.$nextTick(function () {
        //     this.datasource.searchData = this.searchData
        // });
    }
}
</script>
<style scoped>
#stockResearchGrid {
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/warehouse/StockResearch.vue